export default __webpack_public_path__ + "02ab338a02000e226360ae0755f35ff0.svg";